module.exports = __webpack_public_path__ + "assets/img/one.b7db5d76.png";